import { post } from '../../../../DAL/data-provider';
import { PaymentTabsEnum } from '../../cart-bridger-pay/enums/payment-tabs-enum';

export const performOrderManualCharge = async (
    customTableGuid: string,
    paymentType: PaymentTabsEnum,
    newCreditCardToken: string,
    phone: string,
    billingAddress: string,
    shippingAddress: string,
    encryptedCvv: string,
    cvv: string,
    cardChecksum: string
) => {
    return post('/api/bridgerpay/omc', {
        customTableGuid,
        paymentType,
        paymentMethodToken: newCreditCardToken,
        phone,
        billingAddress,
        shippingAddress,
        encryptedCvv,
        cvv,
        cardChecksum,
    });
};

export const createCashierTokenOmc = async () => {
    return post('/api/bridgerpay/create-cashier-token-omc', {});
};